import { render, staticRenderFns } from "./AppcenterManage.vue?vue&type=template&id=2c748731&"
import script from "./AppcenterManage.vue?vue&type=script&lang=js&"
export * from "./AppcenterManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports